import { z } from "zod";

/**
 * Canonical E.164 phone number ID (always starts with +).
 * Example: +12025551234
 */
export const PhoneE164Schema = z
	.string()
	.regex(
		/^\+[1-9]\d{1,14}$/,
		"Phone number must be in E.164 format (e.g., +1234567890)"
	)
	.brand("PhoneE164");

export type PhoneE164 = z.infer<typeof PhoneE164Schema>;

export function createPhoneE164(value: string): PhoneE164 {
	return PhoneE164Schema.parse(value);
}

export function isPhoneE164(value: unknown): value is PhoneE164 {
	return PhoneE164Schema.safeParse(value).success;
}
